// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"tJ-z","carousel":"uJ-z"};